

async function uploadImage(API_BASE, file, token, manifestation_id) {

    const formData = new FormData();
    formData.append('file', file);
    formData.append('manifestation_id', manifestation_id);

    const res = await fetch(`${API_BASE}/upload`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        },
        body: formData
    });

    if (!res.ok) {
        throw new Error("Erreur lors de l'upload de l'image : " + (await res.text()));
    }

    const data = await res.json();
    // On suppose que l'API renvoie { url: "..." } ou { path: "..." }
    return data.url || data.path;
}

export default uploadImage;
